import React from 'react';
import {connect} from 'react-redux';
import {
	closeFindYourProjectPopup,
	updateEditFindYourProjectSection,
} from '../../actions';

import {
	changeFindYourProjectProjects,
	changeFindYourProjectDestinations,
	updateTitleFieldInTheSectionEditPopup,
} from '../../sections/actions';

import FindYourProjectSectionEditPopup from './find_your_project_section_edit';
import {fetchTypesOfWork, fetchDestinations} from "../../../taxonomy/thunks";

class FindYourProjectPopup extends React.Component {

	componentWillMount() {
		this.props.fetchTypesOfWork();
		this.props.fetchDestinations();
	}

	render () {

		return (
			<FindYourProjectSectionEditPopup
				open={this.props.findYourProjectSectionEditOpen}
				pageId={this.props.pageId}
				sectionId={this.props.findYourProjectSectionId}
				title={this.props.findYourProjectSectionTitle}
				projects={this.props.projects}
				selectedProjects={this.props.selectedProjects}
				onProjectsChange={this.props.changeFindYourProjectProjects}
				destinations={this.props.destinations}
				selectedDestinations={this.props.selectedDestinations}
				onDestinationsChange={this.props.changeFindYourProjectDestinations}
				onUpdateTitleField={
					title => this.props.updateFindYourProjectSectionTitleField(title)
				}
				onHandleSubmit={() =>
					this.props.updateFindYourProjectSectionContents(
						this.props.pageId,
						this.props.findYourProjectSectionId,
						this.props.sectionData,
					)
				}
				onHandleClose={
					() => this.props.closeFindYourProjectSectionPopup()
				}
			/>
		)
	}


}

const mapStateToProps = (state, props) => ({
	sectionData: state.pageBuilderSectionPopup.data,
	findYourProjectSectionEditOpen: state.pageBuilder.findYourProjectSectionPopup.open,
	findYourProjectSectionId: state.pageBuilderSectionPopup.sectionId,
	findYourProjectSectionTitle: state.pageBuilderSectionPopup.data.title,
	projects: state.taxonomy.allTypesOfWork,
	destinations: state.taxonomy.allDestinations,
	selectedProjects: state.pageBuilderSectionPopup.data.projects,
	selectedDestinations: state.pageBuilderSectionPopup.data.destinations,
});

export default connect(
	mapStateToProps, {
		fetchTypesOfWork,
		fetchDestinations,
		changeFindYourProjectProjects,
		changeFindYourProjectDestinations,
		updateFindYourProjectSectionTitleField: updateTitleFieldInTheSectionEditPopup,
		closeFindYourProjectSectionPopup: closeFindYourProjectPopup,
		updateFindYourProjectSectionContents: updateEditFindYourProjectSection,
	}
)(FindYourProjectPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/find_your_project_popup.js